<template>
    <div class="gate-page">

        <button v-if="currentUser === 'root'"  @click="goToDeviceManager" class="top-right-btn">用户设备配置</button>

        <h1 class="gate-title">设备管理</h1>

        <div class="gate-container">

            <button
            class="gate-button"
            @click="handleFirstButtonClick"
            style="font-size: 24px; font-weight: bold;"
            >
              {{ isBoss ? "查看所有设备结果" : "查看所有设备登录历史" }}
            </button>

            <button class="gate-button" @click="viewDeviceInfo" style="font-size: 24px; font-weight: bold;">查看所有设备信息</button>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Gate',
    data() {
        return {
            currentUser: "",
        };
    },
    computed: {
        isBoss() {
            return this.currentUser === "Boss";  // 视图自动响应更新
        }
    },
    mounted() {
        this.currentUser = localStorage.getItem("currentUser") || "";
        console.log("当前用户是：", this.currentUser);
    },
    methods: {
        viewLoginHistory() {
            this.$router.push('/device-login-history');
        },
        viewAllDeviceResults() {
            this.$router.push('/all-device-results');
        },
        handleFirstButtonClick() {
            if (this.currentUser === 'Boss') {
                this.viewAllDeviceResults();
            } else {
                this.viewLoginHistory();
            }
        },
        viewDeviceInfo() {
            this.$router.push('/device-info');
        },
        goToDeviceManager() {
            this.$router.push('/UserDeviceManager');
        }
    }
}
</script>

<style scoped>
.gate-page {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    padding-top: 0px; /* 设置上边距 */
}

.gate-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 50px; /* 增加边距和按钮保持距离 */
}

.gate-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 800px;
}

.gate-button {
    width: 600px;
    height: 600px;
    font-size: 18px;
    background-color: #f9f9f9;
    color: black;
    border: 1px solid #ccc;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.gate-button:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #2ab1f4;
    transition: box-shadow 0.3s;
    transform: scale(1.05); /* 悬停时稍微放大 */
}

.gate-page {
  position: relative; /* 让右上角按钮定位基于此容器 */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  padding-top: 0px;
}

.top-right-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  padding: 10px 20px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  transition: all 0.3s ease;
}

.top-right-btn:hover {
  background-color: #1565c0;
  transform: scale(1.05);
}

.gate-title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 50px;
}

.gate-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 800px;
}

.gate-button {
  width: 600px;
  height: 600px;
  font-size: 18px;
  background-color: #f9f9f9;
  color: black;
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.gate-button:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #2ab1f4;
  transition: box-shadow 0.3s;
  transform: scale(1.05);
}
</style>